import React from "react";
import { useTranslation } from "react-i18next";
import "./ErrorMessageModalComponent.css";
import "./AgeRestrictionModalComponent.css";
import { AGE_RESTRICTION_18_PLUS } from "../../Utils/Constants";

const AgeRestrictionModalComponent = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="ModalBackground">
      <div className="ErrorMessageModal">
        <div className="age-restriction-badge">{AGE_RESTRICTION_18_PLUS}</div>
        <div className="age-restriction-header">
          <strong className="ErrorModalTitle">
            {t("error.modal.age.restriction.title")}
          </strong>
        </div>
        <div className="ModalContent">
          <p>{t("error.modal.age.restriction.message")}</p>
        </div>
        <div className="ButtonContainer">
          <button onClick={onClose} className="BotonVer BotonVerV2">
            {t("global.button.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeRestrictionModalComponent;
